import { Row, Col } from 'react-bootstrap';

export default function RemuneracaoAjudaDeputados() {
    return (
        <Row>
            <Col xs="12">
                <p><small>Você está em <a href="/financas">Prestação de Contas</a> / Remuneração e Ajuda de Custo dos Deputados</small></p>
            </Col>
            <Col xs="12">
                <h1>REMUNERAÇÃO E AJUDA DE CUSTO DOS DEPUTADOS</h1>
                <p>A remuneração do deputado constitui-se de subsídio mensal no valor correspondente a até 75% da remuneração do deputado federal, conforme o parágrafo 2º do artigo 27 da Constituição Federal. O valor do subsídio é estabelecido na Lei Estadual nº 18.138/2023:</p>
                <p>R$ 31.238,19 , desde 1º de abril de 2023</p>
                <p>R$ 33.006,39 a partir de 1º de fevereiro de 2024</p>
                <p>R$ 34.774,64 a partir de 1º de fevereiro de 2025.</p>
                <p>O pagamento da ajuda de custo, que corresponde ao mesmo valor do subsídio, será feito no início e no final de cada Legislatura, a requerimento do interessado dirigido ao Presidente da Assembleia Legislativa.</p>
            </Col>
        </Row>
        )
}